module.exports = __webpack_public_path__ + "static/img/farming.4fbd0bd9.png";